var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { checkPasswordStrength } from '@@/Util';
import { Box, Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spinner, Text } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
// import {checkPasswordStrength} from '../../../../letrcore/src/Util';
// import {CommonCrypto} from '../../../../letrcore/src/Cryptography';
import { observer } from 'mobx-react';
import React from 'react';
// import { security } from '../security/Security';
// import { SECRET_STORE } from '../store/SecretStore';
// import { TiAdjustContrast } from 'react-icons/ti';
export class NewUserPinState {
    constructor() {
        this.open = false;
        this.okcb = (pin) => console.log("absorb");
        this.password = "";
        this.errormsg = "";
        this.resetting = false;
        this.userid = "";
        makeObservable(this);
    }
    setOpen(open) {
        if (this.resetting) {
            return;
        }
        if (!this.userid) {
            this.open = false;
            return;
        }
        this.open = open;
        if (!this.open) {
            this.userid = "";
        }
    }
    setResetting(reset) {
        this.resetting = reset;
    }
    setOKCb(cb) {
        this.okcb = cb;
    }
    setPassword(password) {
        this.password = password;
    }
    setErrorMessage(msg) {
        this.errormsg = msg;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], NewUserPinState.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewUserPinState.prototype, "password", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewUserPinState.prototype, "errormsg", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewUserPinState.prototype, "resetting", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], NewUserPinState.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], NewUserPinState.prototype, "setResetting", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], NewUserPinState.prototype, "setOKCb", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewUserPinState.prototype, "setPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewUserPinState.prototype, "setErrorMessage", null);
let NewUserPinDialog = class NewUserPinDialog extends React.Component {
    constructor(prop) {
        super(prop);
    }
    async reset() {
        this.props.pinstate.setErrorMessage("");
        this.props.pinstate.setResetting(true);
        const password = this.props.pinstate.password.trim();
        if (!password || !checkPasswordStrength(password)) {
            this.props.pinstate.setErrorMessage("Password should be minimum 6 characters long and must contain atleast one number, one special character");
            this.props.pinstate.setResetting(false);
            return;
        }
        this.props.pinstate.okcb(password);
    }
    render() {
        return (React.createElement(Modal, { isOpen: this.props.pinstate.open, onClose: () => console.log("absorb") },
            React.createElement(ModalOverlay, null),
            React.createElement(ModalContent, null,
                React.createElement(ModalHeader, null, "New Password"),
                React.createElement(ModalBody, { minH: '140px' },
                    React.createElement(Input, { errorBorderColor: "red.300", isInvalid: this.props.pinstate.errormsg.length > 0 ? true : false, type: 'password', placeholder: 'New Password', onChange: (e) => this.props.pinstate.setPassword(e.target.value), value: this.props.pinstate.password }),
                    this.props.pinstate.errormsg != "" && React.createElement(Text, { color: 'red' }, this.props.pinstate.errormsg)),
                React.createElement(ModalFooter, null,
                    React.createElement(Button, { disabled: this.props.pinstate.resetting, colorScheme: "red", mr: 3, onClick: () => this.props.pinstate.setOpen(false) }, "Cancel"),
                    React.createElement(Box, { width: '60px' },
                        this.props.pinstate.resetting && React.createElement(Spinner, null),
                        !this.props.pinstate.resetting && React.createElement(Button, { onClick: () => this.reset(), colorScheme: "blue" }, "Reset"))))));
    }
};
NewUserPinDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], NewUserPinDialog);
export { NewUserPinDialog };
